import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { RootState } from '../../../../store/store';
import LinearFileUpload from '../../../../components/common/LinearFileUpload/LinearFileUpload';
import OptimizerTable from './../OptimizerTable/OptimizerTable';
import { Container, ContentWrapper, ErrorContainer, ErrorIconWrapper } from './OptimizerList.styles';

const isRegionRestricted = (errorMessage: string | null): boolean => {
  if (!errorMessage) return false;
  const lowerMessage = errorMessage.toLowerCase();
  return (
    lowerMessage.includes('region') ||
    lowerMessage.includes('country') ||
    lowerMessage.includes('not available') ||
    lowerMessage.includes('prohibited') ||
    lowerMessage.includes('unsupported') ||
    lowerMessage.includes('not supported')
  );
};
const OptimizerList: React.FC = () => {
  const { t } = useTranslation(['optimizer', 'common']);
  const navigate = useNavigate();
  const { status, records } = useSelector((state: RootState) => state.uploadAndAnalyzeAiState);

  useEffect(() => {
    if (status === 'none') {
      navigate('/optimizer');
    }
  }, [status, navigate]);
  const handleTryAgain = () => {
    navigate('/optimizer');
  };

  const getErrorMessage = (): string => {
    if (!records) {
      return t('common:messages.error');
    }
    if (isRegionRestricted(records)) {
      return t('optimizer:optimization.regionRestricted');
    }
    return t('optimizer:optimization.tryAgain');
  };
  if (status === 'loading') {
    return (
      <Container>
        <ContentWrapper>
          <LinearFileUpload />
        </ContentWrapper>
      </Container>
    );
  }
  if (status === 'failed') {
    return (
      <Container>
        <ErrorContainer>
          <ErrorIconWrapper>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 64 }} />
          </ErrorIconWrapper>
          <Typography variant="h5" gutterBottom>
            {t('optimizer:optimization.failed')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
            {getErrorMessage()}
          </Typography>
          <Button variant="contained" onClick={handleTryAgain}>
            {t('common:buttons.resend')}
          </Button>
        </ErrorContainer>
      </Container>
    );
  }
  return (
    <>
      <OptimizerTable data={records} />
    </>
  );
};
export default OptimizerList;
